import React from 'react'
import { Linking, StyleProp, View, ViewStyle, StyleSheet } from 'react-native'
import { BtText } from '@linqpal/components/src/ui'
import { PhoneIconBlue } from '../../../../assets/icons'
import { currencyMask } from '../../../../utils/helpers/masking'
import { useTranslation } from 'react-i18next'
import { parsePhoneNumber } from 'libphonenumber-js'

interface CompanyHeaderProps {
  name: string
  phone: string
  totalAmount: number
  style: StyleProp<ViewStyle>
  companyFontSize?: number
}

export const CompanyHeader_v2: React.FC<CompanyHeaderProps> = ({
  name,
  phone,
  totalAmount,
  style,
  companyFontSize = 18,
}) => {
  const { t } = useTranslation('global')

  const handlePhonePress = () => {
    Linking.openURL(`tel:${phone}`)
  }

  const formattedPhone = phone
    ? parsePhoneNumber(phone, 'US').formatInternational().slice(3)
    : null
  const formattedPhoneWithParentheses = formattedPhone
    ? `(${formattedPhone.slice(0, 3)})${formattedPhone.slice(3)}`
    : null

  return (
    <View style={[styles.container, style]} testID="company-info-container">
      {/* Company Information */}
      <View style={styles.companyInfo}>
        <BtText
          size={companyFontSize}
          weight="700"
          style={styles.companyName}
          numberOfLines={1}
          ellipsizeMode="tail"
          testID="company-name"
        >
          {name}
        </BtText>
        {phone && (
          <View style={styles.phoneContainer} testID="company-phone-container">
            <PhoneIconBlue />
            <BtText
              style={styles.phoneText}
              weight="500"
              onPress={handlePhonePress}
              testID="company-phone"
            >
              {formattedPhoneWithParentheses}
            </BtText>
          </View>
        )}
      </View>

      {/* Amount Due */}
      <View style={styles.amountDueContainer} testID="amount-due-container">
        <BtText
          weight="700"
          size={18}
          style={styles.amountValue}
          testID="amount-due-value"
        >
          {currencyMask(totalAmount)}
        </BtText>
        <BtText
          style={styles.amountTitle}
          weight="500"
          testID="amount-due-title"
        >
          {t('TabInvoice.amount_due')}
        </BtText>
      </View>
    </View>
  )
}

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
  },
  companyInfo: {
    flex: 1,
  },
  companyName: {
    lineHeight: 28,
    letterSpacing: 0.032,
    fontFamily: 'Inter',
    color: '#001929',
  },
  phoneContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    marginTop: 7,
  },
  phoneText: {
    color: '#00A0F3',
    marginLeft: 5,
    fontFamily: 'Inter',
    lineHeight: 21,
    fontSize: 14,
  },
  amountDueContainer: {
    alignItems: 'flex-end',
  },
  amountValue: {
    fontFamily: 'Inter',
    lineHeight: 28,
    letterSpacing: 0.032,
    color: '#001929',
  },
  amountTitle: {
    color: '#394D5A',
    lineHeight: 21,
    fontSize: 14,
    fontFamily: 'Inter',
    marginTop: 6,
  },
})
